import { HTMLAttributes } from 'react';

import logoWhite from 'v3/assets/svg/logo-white.svg';
import logoPurple from 'v3/assets/svg/logo-purple.svg';
import logoBeta from 'v3/assets/svg/savings-club-beta-logo.svg';

export interface LogoProps extends HTMLAttributes<HTMLImageElement> {
  variant?: 'primary' | 'secondary' | 'beta';
}

const Logo = ({ variant = 'primary', ...props }: LogoProps) => {
  const variantMapper = {
    primary: logoPurple,
    secondary: logoWhite,
    beta: logoBeta,
  };

  return (
    <img src={variantMapper[variant]} alt="Savings Club Logo" {...props} />
  );
};

export default Logo;
